/**
 * setNextAvailableSlot asyncronous
 */
function setNextAvailableSlot() {
    let url = $('.nextAvailableSlot').data('action');
    const storeId = $('#selectStoreHeader').data('preferredstoreid');
    url = `${url}?storeid=${storeId}`;

    $.ajax({
        url,
        type: 'get',
        dataType: 'html',
        success(response) {
            $('.nextAvailableSlot').empty();
            $('.nextAvailableSlot').append(response);

            const htmlSnippet = `${'<table><tr class="store-address"><td>' +
                '<i class="fa fa-clock-o" aria-hidden="true"></i>' +
            '</td><td class="pl-2">'}${
                response
            }</td></tr></table>`;

            $('.storelist-mobile').find(`.storeListNextAvailableSlot[data-storeid='${storeId}']`).append(htmlSnippet);
            $('.storelist-desktop').find(`.storeListNextAvailableSlot[data-storeid='${storeId}']`).append(htmlSnippet);
        },
    });
}

module.exports = {
    setNextAvailableSlot() {
        /**
         * update next available slot if store selected but no slot selected
         */
        if ($('.nextAvailableSlot').length > 0) {
            setNextAvailableSlot();
        }
    },
};
